<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <!-- Standard Transfer Selection Dialog -->
  <p-dialog
    [header]="'Select_Standard_Transfer_Type' | translateWF: 'Select Transfer Type'"
    [visible]="showStandardDialog()"
    (visibleChange)="showStandardDialog.set($event)"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '500px' }"
  >
    <div class="col">
      @for (option of standardTransferOptions(); track option.id) {
        <div class="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 hover:border-primary transition-all" (click)="selectStandardTransferOption(option)">
          <div class="row-start-center gap-3">
            <i [class]="option.icon + ' text-xl text-primary'"></i>
            <div class="flex-1">
              <div class="font-semibold text-gray-800">{{ option.label }}</div>
              <div class="text-sm text-gray-500 mt-1">{{ option.fromLabel }} → {{ option.toLabel }}</div>
            </div>
            <i class="pi pi-chevron-right text-gray-400"></i>
          </div>
        </div>
      }
    </div>
  </p-dialog>

  <!-- Relocation Warehouse Selection Dialog -->
  <p-dialog
    [header]="'Select_Relocation_Type' | translateWF: 'Select Relocation Type'"
    [visible]="showRelocationDialog()"
    (visibleChange)="showRelocationDialog.set($event)"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '500px' }"
  >
    <div class="col">
      @for (option of relocationTypeOptions(); track option.id) {
        <div class="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 hover:border-primary transition-all" (click)="selectRelocationOption(option.warehouse)">
          <div class="row-start-center gap-3">
            <i [class]="option.icon + ' text-xl text-primary'"></i>
            <div class="flex-1">
              <div class="font-semibold text-gray-800">{{ option.label }}</div>
              <div class="text-sm text-gray-500 mt-1">{{ option.fromLabel }} → {{ option.toLabel }}</div>
              <div class="text-xs text-gray-400 mt-1">{{ option.description }}</div>
            </div>
            <i class="pi pi-chevron-right text-gray-400"></i>
          </div>
        </div>
      }
    </div>
  </p-dialog>

  <!-- Batch Selection Dialog (for TransferToFinishedGoods) -->
  <p-dialog
    [header]="'Select_Batch' | translateWF: 'Select Batch'"
    [visible]="showBatchSelectionDialog()"
    (visibleChange)="showBatchSelectionDialog.set($event)"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '450px' }"
  >
    <div class="col">
      <div>
        <label class="block text-gray-600 mb-2">{{ 'Batch' | translateWF: 'Batch' }} <span class="text-red-500">*</span></label>
        <p-autoComplete
          styleClass="w-full"
          #batchSearchRef="cslServerSearch"
          [cslServerSearch]="fetchBatches"
          [suggestions]="batchSearchRef.results()"
          (onSelect)="onBatchSelect($event)"
          field="number"
          [dropdown]="false"
          [placeholder]="'Search_Batch' | translateWF: 'Search batch...'"
        />
      </div>
      @if (selectedBatchForTransfer()) {
        <div class="p-3 bg-gray-50 rounded-lg">
          <div class="text-sm text-gray-500">{{ 'Selected_Batch' | translateWF: 'Selected Batch' }}</div>
          <div class="font-semibold">{{ selectedBatchForTransfer()!.number }}</div>
          <div class="text-sm text-gray-600 mt-1">{{ selectedBatchForTransfer()!.productDevelopmentNumber }}</div>
        </div>
      }
      <div class="row-end-stretch gap-2">
        <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" variant="outlined" (click)="cancelBatchSelection()" />
        <p-button
          [label]="'Create_Transfer' | translateWF: 'Create Transfer'"
          icon="pi pi-check"
          (click)="confirmBatchAndCreateTransfer()"
          [disabled]="!selectedBatchForTransfer()"
        />
      </div>
    </div>
  </p-dialog>

  <!-- Sub-Location Selection Dialog (for Sample Transfers) -->
  <p-dialog
    [header]="'Select_Sample_Destination' | translateWF: 'Select Sample Destination'"
    [visible]="showSubLocationDialog()"
    (visibleChange)="showSubLocationDialog.set($event)"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [style]="{ width: '450px' }"
  >
    <div class="col">
      <p class="text-sm text-gray-500 mb-2">
        {{
          'Select_Sub_Location'
            | translateWF
              : 'Seleccione la ubicación destino
        para la muestra:'
        }}
      </p>
      @for (subLoc of sampleSubLocations; track subLoc.code) {
        <div class="p-4 border border-gray-200 rounded-lg cursor-pointer hover:bg-gray-50 hover:border-primary transition-all" (click)="selectSubLocation(subLoc)">
          <div class="row-start-center gap-3">
            <i class="pi pi-map-marker text-xl text-primary"></i>
            <div class="flex-1">
              <div class="font-semibold text-gray-800">{{ subLoc.label }}</div>
              <div class="text-sm text-gray-500 mt-1">{{ subLoc.code }}</div>
            </div>
            <i class="pi pi-chevron-right text-gray-400"></i>
          </div>
        </div>
      }
      <div class="row-end-stretch mt-2">
        <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" variant="outlined" (click)="cancelSubLocationSelection()" />
      </div>
    </div>
  </p-dialog>

  <!-- Sample Notes Dialog (after sub-location selection) -->
  <p-dialog
    [header]="'Sample_Notes' | translateWF: 'Razón de la muestra'"
    [visible]="showNotesDialog()"
    (visibleChange)="showNotesDialog.set($event)"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="false"
    [style]="{ width: '550px' }"
  >
    <div class="col">
      <p class="text-sm text-gray-500">
        {{
          'Sample_Reason_Instructions'
            | translateWF
              : 'Indique la razón de la muestra
        antes de crear la transferencia.'
        }}
      </p>
      @if (userLite) {
        <csl-standard-notes [userLite]="userLite" [notes]="[]" [viewOnly]="false" (noteAdded)="onSampleNoteAdded($event)"></csl-standard-notes>
      }
      <div class="row-end-stretch gap-2">
        <p-button [label]="'Cancel' | translateWF: 'Cancel'" severity="secondary" variant="outlined" (click)="cancelNotesDialog()" />
        <p-button
          [label]="'Create_Transfer' | translateWF: 'Create Transfer'"
          icon="pi pi-check"
          (click)="confirmNotesAndCreateTransfer()"
          [disabled]="pendingNotes().length === 0"
        />
      </div>
    </div>
  </p-dialog>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Lot_Item_Transfers_Title' | translateWF: 'Lot Item Transfers' }}</h1>
        @if (canEdit()) {
          <div class="page__title__buttons">
            <p-speedDial [model]="speedDialItems()" direction="left" [transitionDelay]="80">
              <ng-template #button let-toggleCallback="toggleCallback">
                <p-button (click)="toggleCallback($event)" [label]="'Lot_Item_Transfers_Add' | translateWF: 'Add'" icon="pi pi-plus" iconPos="left" />
              </ng-template>
              <ng-template #item let-item let-toggleCallback="toggleCallback">
                <p-button variant="outlined" severity="secondary" (click)="toggleCallback($event, item)" [label]="item.label | translateWF: item.label" />
              </ng-template>
            </p-speedDial>
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table Panel -->
      <p-panel [header]="'Lot_Item_Transfers_Title' | translateWF: 'Lot Item Transfers'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="lotItemTransfers()" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'Lot_Item_Transfers_Number' | translateWF: 'Transfer Number' }}</th>
                <th>{{ 'Lot_Item_Transfers_Type' | translateWF: 'Type' }}</th>
                <th>{{ 'Lot_Item_Transfers_From_Location' | translateWF: 'From Location' }}</th>
                <th>{{ 'Lot_Item_Transfers_To_Location' | translateWF: 'To Location' }}</th>
                <th>{{ 'Lot_Item_Transfers_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Lot_Item_Transfers_Items_Count' | translateWF: 'Items' }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transfer>
              @let transferStrict = getTransferStrict(transfer);
              <tr class="cursor-pointer" (click)="redirectToDetails(transfer.id)">
                <td>
                  <a>{{ transfer.number }}</a>
                </td>
                <td>
                  <p-tag
                    [value]="getTransferTypeLabel(transferStrict.transferType)"
                    [severity]="getTransferTypeSeverity(transferStrict.transferType)"
                    [icon]="getTransferTypeIcon(transferStrict.transferType)"
                  />
                </td>
                <td>{{ transferStrict.fromLocationName || transferStrict.fromLocationCode }}</td>
                <td>{{ transferStrict.toLocationName || transferStrict.toLocationCode }}</td>
                <td>{{ getStatusLabel(transfer.status) }}</td>
                <td>{{ getItemsCount(transferStrict) }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6">
                  {{ 'Lot_Item_Transfers_Not_Found' | translateWF: 'No Lot Item Transfers Found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <!-- Pagination -->
          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
            class="mt-4"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
